import React from 'react';
import { Modal } from 'antd';
import { Text, Box, Flex } from '../../../shared/components';
import {
  number, string,
} from 'prop-types';
import gafasGraduadasSVG from '../../assets/img/Gafas graduadas.svg';
import gafasSolSVG from '../../assets/img/Gafas de sol.svg';
import lentesContactoSVG from '../../assets/img/Lentes de contacto.svg';
import audioSVG from '../../assets/img/Audio.svg';
import otrosArticulosSVG from '../../assets/img/Otros articulos.svg';

export default class AddArticulosModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  show() {
    this.setState({ visible: true });
  }

  hide() {
    this.setState({
      visible: false,
    });
  }

  renderOption(translationId, imagen, url, sinMargen) {
    const { history } = this.props;
    const margen = sinMargen ? '0px' : '16px';
    return (
      <Flex p="8px" justifyContent="space-between" flexDirection="column" mr={margen} onClick={() => history.push(url)} width="288px" height="198px" border="1px solid #D9D9D9">
        <Text translationId={translationId} />
        <Flex height="100%" justifyContent="center" alignItems="center"><img alt={translationId} src={imagen} /></Flex>
      </Flex>
    );
  }

  render() {
    const { linea, encargoUUID } = this.props;
    const { visible } = this.state;
    return (
      <Modal
        title={(
          <Box>
            <Box><Text fontSize="20" fontWeight="600" translationId="encargos.añadir_articulos" /></Box>
            <Box><Text fontSize="14" color="#777572">Subtitulo</Text></Box>
          </Box>
        )}
        visible={visible}
        onCancel={() => this.hide()}
        okButtonProps={{ style: { display: 'none' } }}
        cancelText="Cancelar"
        width="fit-content"
      >
        <Box>
          <Flex>
            {this.renderOption('encargos.gafas_graduadas', gafasGraduadasSVG, `encargo/${encargoUUID}/seleccionarGafa/tipo/3/linea/${linea}`)}
            {this.renderOption('encargos.gafas_sol', gafasSolSVG, `encargo/${encargoUUID}/seleccionarArticulo/tipo/5/linea/${linea}`)}
            {this.renderOption('encargos.lentes_contacto', lentesContactoSVG, `encargo/${encargoUUID}/seleccionarArticulo/tipo/2/linea/${linea}`, true)}
          </Flex>
          <Flex>
            {this.renderOption('encargos.audio', audioSVG, `encargo/${encargoUUID}/seleccionarArticulo/linea/${linea}`)}
            {this.renderOption('encargos.otros_articulos', otrosArticulosSVG, `encargo/${encargoUUID}/seleccionarArticulo/linea/${linea}`, true)}
          </Flex>
        </Box>
      </Modal>
    );
  }
}

AddArticulosModal.propTypes = {
  linea: number.isRequired,
  encargoUUID: string.isRequired,
};

AddArticulosModal.defaultProps = {
};
